const automationActionType = {
  // automations
  FETCH_AUTOMATIONS: "FETCH_AUTOMATIONS",
  FETCH_AUTOMATIONS_SUCCESS: "FETCH_AUTOMATIONS_SUCCESS",
  FETCH_AUTOMATIONS_FAILURE: "FETCH_AUTOMATIONS_FAILURE",
  // edit automations
  EDIT_AUTOMATIONS_FAILURE: "EDIT_AUTOMATIONS_FAILURE",
};

export default automationActionType;
